import React from 'react';
import { ContentCopy as CopyIcon } from '@mui/icons-material';
import { IconButton } from '@mui/material';
import { useColors } from 'legacyfrontend/hooks/useColors';
import { useToast } from 'legacyfrontend/hooks/useToast';
import { useTranslation } from 'react-i18next';
import { isClient } from 'legacyfrontend/helpers/ssr-helper';
import ErrorSnackbar from 'legacyfrontend/components/ErrorSnackbar';

const ShareButton = ({ 
  url, 
  title = 'Compartir',
  size = 'medium',
  className = '',
  onShare = () => {},
  variant = 'package'
}) => {
  const { background } = useColors();
  const { toastState, showSuccess, hideToast } = useToast();
  const { t } = useTranslation('layout');

  const handleShareClick = async () => {
    if (!isClient) return;
    
    const message = variant === 'banner' 
      ? 'Banner copiado'
      : 'Paquete copiado';
    
    if (toastState.open) {
      hideToast();
      setTimeout(() => {
        showSuccess(message, 3000);
      }, 100);
    } else {
      showSuccess(message, 3000);
    }
    
    try {
      const urlToCopy = url || window.location.href;
      await navigator.clipboard.writeText(urlToCopy);
      onShare(urlToCopy);
    } catch (err) {
      console.error('Error copying to clipboard:', err);
      const urlToCopy = url || window.location.href;
      const textArea = document.createElement('textarea');
      textArea.value = urlToCopy;
      document.body.appendChild(textArea);
      textArea.select();
      document.execCommand('copy');
      document.body.removeChild(textArea);
      onShare(urlToCopy);
    }
  };

  return (
    <>
      <IconButton
        onClick={handleShareClick}
        size="small"
        className={className}
        sx={{
          width: 28,
          height: 28,
          padding: 0,
          transition: 'transform 0.2s ease-in-out',
          '&:hover': {
            transform: 'translateY(-2px)',
          }
        }}
      >
        <CopyIcon fontSize="small" />
      </IconButton>
      
      <ErrorSnackbar
        open={toastState.open}
        message={toastState.message}
        severity={toastState.severity}
        onClose={hideToast}
      />
    </>
  );
};

export default ShareButton;
